
export const style = (theme) => ({
    ".subheader-shell": {
        width: "100%",
    },
    ".breadcrumb-track .MuiChip-root": {
        fontWeight: 600,
    },
});


